import { render } from "./App.vue?vue&type=template&id=e8072b5e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e8072b5e&lang=css"

import exportComponent from "/home/tikam/Documents/2023/Ferat/FERAT FINAL/routerlinks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__